export enum GameModeType {
  TEST = "test",
  LEARN = "learn",
}
